import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles/main.css'
import './styles/index.css'
import './styles/notFound.css'
import './styles/boton_atras.css'
import './styles/timeline.css'
import './styles/estetic.css'
import './styles/galery.css'

createRoot(document.getElementById('root')).render(<App />)
